<mat-card class="regulatory-title-card">
  <mat-card-header>
    <mat-card-title>{{ 'SMS_REGULATION.ITALY.TITLE' | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'SMS_REGULATION.ITALY.SUBTITLE' | translate }}</mat-card-subtitle>
  </mat-card-header>
</mat-card>

<form [formGroup]="formGroup">
  <fieldset
    class="regulatory-form-lock"
    [disabled]="$shouldFormBeLocked()"
    [attr.inert]="$shouldFormBeLocked() ? '' : null"
  >
  <div class="regulatory-form">
    <div class="regulatory-form-column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'SMS_REGULATION.ITALY.BUSINESS.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content formGroupName="business">
          <glxy-form-field>
            <glxy-label>{{ 'SMS_REGULATION.ITALY.BUSINESS_TYPE.LABEL' | translate }}</glxy-label>
            <mat-radio-group
              [value]="isSoleProprietor()"
              (change)="isSoleProprietor.set($event.value)"
            >
              <mat-radio-button [value]="false">
                {{ 'SMS_REGULATION.ITALY.BUSINESS_TYPE.BUSINESS' | translate }}
              </mat-radio-button>
              <mat-radio-button [value]="true">
                {{ 'SMS_REGULATION.ITALY.BUSINESS_TYPE.SOLE_PROPRIETOR' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </glxy-form-field>
          <glxy-form-field [required]="true">
            @if (isSoleProprietor()) {
              <glxy-label>{{ 'SMS_REGULATION.ITALY.BUSINESS.SOLE_PROPRIETOR.BUSINESS_NAME' | translate }}</glxy-label>
            } @else {
              <glxy-label>{{ 'SMS_REGULATION.ITALY.BUSINESS.BUSINESS_NAME' | translate }}</glxy-label>
            }
            <input matInput formControlName="businessName" />
            @if (businessFormGroup.controls.businessName.hasError('maxlength')) {
              <glxy-error>{{
                'SMS_REGULATION.ITALY.BUSINESS.BUSINESS_NAME_MAX_LENGTH' | translate: { max: maxBusinessNameLength }
              }}</glxy-error>
            }
          </glxy-form-field>
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.ITALY.BUSINESS.VAT' | translate }}</glxy-label>
            <input matInput formControlName="vat" />
          </glxy-form-field>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'SMS_REGULATION.ITALY.BUSINESS_ADDRESS.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <sms-address-fields [parentFormGroup]="businessAddressFormGroup"></sms-address-fields>

          <sms-document-uploader
            [parentFormGroup]="businessAddressFormGroup"
            [options]="addressDocumentOptions()"
            [fieldTitle]="'SMS_REGULATION.ITALY.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.ITALY.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.HINT'"
          ></sms-document-uploader>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="regulatory-form-column">
      <mat-card>
        <mat-card-header>
          @if (isSoleProprietor()) {
            <mat-card-title>{{
              'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.SOLE_PROPRIETOR.TITLE' | translate
            }}</mat-card-title>
          } @else {
            <mat-card-title>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.TITLE' | translate }}</mat-card-title>
          }
        </mat-card-header>
        <mat-card-content formGroupName="contact">
          <glxy-form-row>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.FIRST_NAME' | translate }}</glxy-label>
              <input matInput formControlName="contactFirstName" />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.LAST_NAME' | translate }}</glxy-label>
              <input matInput formControlName="contactLastName" />
            </glxy-form-field>
          </glxy-form-row>

          <glxy-form-row>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.BIRTH_DATE' | translate }}</glxy-label>

              <mat-datepicker-toggle matPrefix [for]="birthDatePicker" />
              <input
                matInput
                formControlName="contactBirthDate"
                [matDatepicker]="birthDatePicker"
                placeholder="Select birth date"
              />

              <mat-datepicker #birthDatePicker />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.BIRTH_PLACE' | translate }}</glxy-label>
              <input matInput formControlName="contactBirthPlace" />
            </glxy-form-field>
          </glxy-form-row>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.NATIONALITY' | translate }}</glxy-label>
            <input matInput formControlName="contactNationality" />
          </glxy-form-field>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.TAX_ID_NUMBER' | translate }}</glxy-label>
            <input matInput formControlName="taxIdNumber" />
          </glxy-form-field>

          <glxy-form-row>
            <glxy-form-field [required]="true">
              <glxy-label>{{
                'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.DOCUMENT_NUMBER' | translate
              }}</glxy-label>
              <glxy-hint>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.DOCUMENT_NUMBER_HINT' | translate }}</glxy-hint>
              <input matInput formControlName="contactDocumentNumber" />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{
                'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.ISSUING_AUTHORITY' | translate
              }}</glxy-label>
              <input matInput formControlName="contactIssuingAuthority" />
            </glxy-form-field>
          </glxy-form-row>

          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.ISSUE_DATE' | translate }}</glxy-label>

            <mat-datepicker-toggle matPrefix [for]="idDocumentIssueDatePicker" />
            <input
              matInput
              formControlName="contactIssueDate"
              [matDatepicker]="idDocumentIssueDatePicker"
              placeholder="Select issue date"
            />

            <mat-datepicker #idDocumentIssueDatePicker />
          </glxy-form-field>

          <sms-document-uploader
            [parentFormGroup]="contactFormGroup"
            [options]="[
              {
                label: 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.GOVERNMENT_ISSUED_ID',
                value: 'government_issued_document',
              },
              {
                label: 'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.PASSPORT',
                value: 'passport',
              },
            ]"
            [fieldTitle]="'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.ITALY.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.HINT'"
          ></sms-document-uploader>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  </fieldset>

  @if (!$shouldFormBeLocked() && !$submitting()) {
    <div class="regulatory-form-action-container">
      <button (click)="submitRegulatoryForm()" color="primary" mat-flat-button type="submit">
        @if ($isRejected()) {
          {{ 'SMS_REGULATION.COMMON.RESUBMIT' | translate }}
        } @else {
          {{ 'SMS_REGULATION.COMMON.SUBMIT' | translate }}
        }
      </button>
    </div>
  }
</form>
